/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ApiUserRequest,
    ApiUserRequestFromJSON,
    ApiUserRequestToJSON,
    ApiUserResponse,
    ApiUserResponseFromJSON,
    ApiUserResponseToJSON,
    ApiUsersResponse,
    ApiUsersResponseFromJSON,
    ApiUsersResponseToJSON,
    BadRequestErrorResponse,
    BadRequestErrorResponseFromJSON,
    BadRequestErrorResponseToJSON,
    ConflictErrorResponse,
    ConflictErrorResponseFromJSON,
    ConflictErrorResponseToJSON,
    NewResourceResponse,
    NewResourceResponseFromJSON,
    NewResourceResponseToJSON,
    NotFoundErrorResponse,
    NotFoundErrorResponseFromJSON,
    NotFoundErrorResponseToJSON,
} from '../models';

export interface CreateApiUserRequest {
    apiUserRequest: ApiUserRequest;
}

export interface ReadApiUserRequest {
    id: string;
}

export interface ReadApiUsersRequest {
    filter?: string | null;
    offset?: number | null;
    limit?: number | null;
}

export interface UpdateApiUserRequest {
    id: string;
    apiUserRequest: ApiUserRequest;
}

export interface UpdateApiUserIsLockedRequest {
    id: string;
    body: boolean;
}

/**
 * 
 */
export class ApiUsersApi extends runtime.BaseAPI {

    /**
     * Create a new API user.
     */
    async createApiUserRaw(requestParameters: CreateApiUserRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<NewResourceResponse>> {
        if (requestParameters.apiUserRequest === null || requestParameters.apiUserRequest === undefined) {
            throw new runtime.RequiredError('apiUserRequest','Required parameter requestParameters.apiUserRequest was null or undefined when calling createApiUser.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/apiUsers`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiUserRequestToJSON(requestParameters.apiUserRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => NewResourceResponseFromJSON(jsonValue));
    }

    /**
     * Create a new API user.
     */
    async createApiUser(requestParameters: CreateApiUserRequest, initOverrides?: RequestInit): Promise<NewResourceResponse> {
        const response = await this.createApiUserRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Read API user by ID.
     */
    async readApiUserRaw(requestParameters: ReadApiUserRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ApiUserResponse>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling readApiUser.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/apiUsers/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiUserResponseFromJSON(jsonValue));
    }

    /**
     * Read API user by ID.
     */
    async readApiUser(requestParameters: ReadApiUserRequest, initOverrides?: RequestInit): Promise<ApiUserResponse> {
        const response = await this.readApiUserRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Read API users.
     */
    async readApiUsersRaw(requestParameters: ReadApiUsersRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ApiUsersResponse>> {
        const queryParameters: any = {};

        if (requestParameters.filter !== undefined) {
            queryParameters['filter'] = requestParameters.filter;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/apiUsers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiUsersResponseFromJSON(jsonValue));
    }

    /**
     * Read API users.
     */
    async readApiUsers(requestParameters: ReadApiUsersRequest = {}, initOverrides?: RequestInit): Promise<ApiUsersResponse> {
        const response = await this.readApiUsersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update API user by ID.
     */
    async updateApiUserRaw(requestParameters: UpdateApiUserRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateApiUser.');
        }

        if (requestParameters.apiUserRequest === null || requestParameters.apiUserRequest === undefined) {
            throw new runtime.RequiredError('apiUserRequest','Required parameter requestParameters.apiUserRequest was null or undefined when calling updateApiUser.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/apiUsers/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ApiUserRequestToJSON(requestParameters.apiUserRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update API user by ID.
     */
    async updateApiUser(requestParameters: UpdateApiUserRequest, initOverrides?: RequestInit): Promise<void> {
        await this.updateApiUserRaw(requestParameters, initOverrides);
    }

    /**
     * Update API user isLocked flag by ID.
     */
    async updateApiUserIsLockedRaw(requestParameters: UpdateApiUserIsLockedRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateApiUserIsLocked.');
        }

        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body','Required parameter requestParameters.body was null or undefined when calling updateApiUserIsLocked.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/apiUsers/{id}/isLocked`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body as any,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update API user isLocked flag by ID.
     */
    async updateApiUserIsLocked(requestParameters: UpdateApiUserIsLockedRequest, initOverrides?: RequestInit): Promise<void> {
        await this.updateApiUserIsLockedRaw(requestParameters, initOverrides);
    }

}
